"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const moment_1 = __importDefault(require("moment"));
const string_utils_1 = require("@/common/string_utils");
function default_1(reg_dt) {
    const localizedRegDt = (0, string_utils_1.changeKSTToLocalTime)(reg_dt);
    const localizedRegDtMoment = (0, moment_1.default)(localizedRegDt);
    const today = (0, moment_1.default)();
    const isSameMinute = localizedRegDtMoment.isSame(today, 'minute');
    const isSameHour = localizedRegDtMoment.isSame(today, 'hour');
    const isSameDay = localizedRegDtMoment.isSame(today, 'day');
    const isSameYear = localizedRegDtMoment.isSame(today, 'year');
    if (isSameMinute)
        return i18next_1.default.t('방금 전');
    else if (isSameHour) {
        const diffMinutes = today.diff(localizedRegDtMoment, 'minutes');
        return i18next_1.default.t('diffMinutes분 전', { diffMinutes });
    }
    else if (isSameDay) {
        const diffHours = today.diff(localizedRegDtMoment, 'hours');
        return i18next_1.default.t('diffHours시간 전', { diffHours });
    }
    else if (isSameYear)
        return localizedRegDtMoment.format('MM/DD');
    else
        return localizedRegDtMoment.format('YY/MM/DD');
}
exports.default = default_1;
